import React, { useEffect, useState } from "react";
import CustomIcons from "../../../icons/kIcons.component";
import BookingDialog from "./booking/dialog";
import BreadCrumbsComp from "../../../navigator/breadcrumbs";
import { TextInput } from "@mantine/core";
import TextField from "../../../inputs/textfield";
import { public_event_bookstatus_details } from "../../../../../src/pages/public/public.api";
import Snackbar from "../../../snackbar/snackbar";
import CustomButton from "../../../inputs/button";
import PaymentDialog from "./booking/updateEvent";
import { error } from "pdf-lib";
import { Button, Modal } from "react-bootstrap";
import moment from "moment";
export default function EventDetail(props) {
  let lang = props.state.language;
  const [data, setData] = useState(props.data);
  const [url, setUrl] = useState(props.url);
  const [booking, setBooking] = useState(false);
  const [paymentData, setPaymentData] = useState(false);
  const [regtype, setRegtype] = useState(false);
  const [bookingId, setBookingId] = useState("");
  const [isActive, setIsActive] = useState(true);
  const servInstance = process.env.REACT_APP_BASE_URL;
  let result = servInstance.substring(0, servInstance?.length - 4);
  const [pendingStatus, setPendingStatus] = useState(null);
  const [approvedStatus, setApprovedStatus] = useState(null);
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [isSnackError, setIsSnackError] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [snackOpen, setSnackOpen] = useState(false);
  const [id, setId] = useState("");
  const [fees, setFees] = useState({});
  const [bookingDetails, setBookingDetails] = useState(null);
  const [paymentDetails, setPaymentDetails] = useState({
    reference_no: "",
    bank_details: "",
    paid_amount: "",
    transaction_date: "",
    mode: "",
  });
  useEffect(() => {
    setData(props.data);

    setUrl(props.url);
  }, [props.data, props.url]);
  const bookingClose = () => {
    setBooking(false);
    console.log(props?.data);
    if (fees?.fees != 0) {
      setPaymentData(true);
    }

    props.fetchEventDetails();
  };
  const bookingModalClose = () => {
    setBooking(false);
  };
  const paymentClose = () => {
    setPendingStatus(false);
    setApprovedStatus(false);
    localStorage.removeItem("amount");
    localStorage.removeItem("booking_id");
  };
  const bookingOpen = () => {
    const regTypes = data[lang]?.registration_types;

    if (!Array.isArray(regTypes) || regTypes.length === 0) {
      setSnackMessage("Registration is Closed for this Event");
      setIsSnackError(true);
      setSnackOpen(true);
      setRegtype(true);
      return;
    }
    setBooking(true);
  };
  const bookingClosed = () => {
    setSnackMessage(
      "Sorry the online registrations for this event are closed now!"
    );
    setIsSnackError(true);
    setSnackOpen(true);
    setRegtype(true);
    return;
  };

  const handleBookingIdChange = (e) => {
    setBookingId(e.target.value.replace(/\s+/g, ""));
  };

  const handleStatusCheck = (id) => {
    setIsActive(true);
    if (id) {
      public_event_bookstatus_details(id)
        .then((res) => {
          localStorage.setItem("amount", res?.amount);
          localStorage.setItem("booking_id", res?.id);
          if (res?.booking_status === "4") {
            if (res?.payment_status === 0) {
              setSnackMessage("Approved without payment");
              setSnackOpen(true);
              setId(res?.booking_id);
              if (res?.amount == 0) {
                setPaymentData(false);
              } else {
                setPaymentData(true);
              }
              // setPaymentData(true);
            } else if (res?.payment_status === 1) {
              setSnackMessage(res?.booking_status_text);
              setSnackOpen(true);
            }
          } else if (res?.booking_status === "1") {
            setSnackMessage(res?.booking_status_text);
            setSnackOpen(true);
          } else if (res?.amount == 0) {
            setSnackMessage(res?.booking_status_text);
            setSnackOpen(true);
          } else {
            setSnackMessage(res?.booking_status_text);
            setSnackOpen(true);
            setId(res?.booking_id);
            setPaymentData(true);
          }
        })
        .catch((error) => {
          setSnackMessage("Invalid Registration Reference Id");
          setIsSnackError(true);
          setSnackOpen(true);
          setIsActive(true);
        });
    }
    setBookingId("");
  };
  const snackbarClose = () => {
    setSnackMessage("");
    setSnackOpen(false);
  };
  const handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let data = paymentDetails;
    data = { ...data, [name]: value };
    setPaymentDetails(data);
  };
  const handleClose = () => {
    setPaymentData(false);
    if (!id) {
      setId(localStorage.getItem("booking_id"));
    }
    setPendingStatus(true);
  };
  return (
    <div className="">
      <div className="bar mb-3 text-center" style={{ fontWeight: "500" }}>
        <h3>{data[lang]?.Title ?? ""}</h3>
      </div>
      
      <div className="row">
        <div className="col-12">
          <div className="bg-img-events">
            {" "}
            <img src={data[lang] && data[lang].image} alt="Event Detail" />
          </div>
        </div>
      </div>

      <div className="container bgc-white">
        {booking && (
          <BookingDialog
            open={booking}
            event={data[lang]}
            handleClose={bookingClose}
            data={data}
            bookingModalClose={bookingModalClose}
            fees={setFees}
          />
        )}
        {paymentData && (
          <Modal
            show={paymentData}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header className="payment-modal">
              <Modal.Title id="contained-modal-title-vcenter">
                Payment Details
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <br />
              <div className="row">
                <div className="col-12 col-md-8">
              <div className="">
                <b>
                  Kindly ensure that you make the payment and share the
                  transaction details with us.
                </b>
              </div>
              <br />
              <div>
                <table className="payment-table-bank">
                  <tbody>
                    <tr>
                      <td className="col-6 fw-bold">Bank Name</td>
                      <td>Canara Bank</td>
                    </tr>
                    <tr>
                      <td className="col-6 fw-bold">Bank Branch</td>
                      <td>Pattom</td>
                    </tr>
                    <tr>
                      <td className="col-6 fw-bold">Account Number</td>
                      <td>110133972146</td>
                    </tr>
                    <tr>
                      <td className="col-6 fw-bold">IFSC Code</td>
                      <td>CNRB0002791</td>
                    </tr>
                    <tr>
                      <td className="col-6 fw-bold">GST No</td>
                      <td>32AAMAK2734Q1Z7</td>
                    </tr>
                    <tr>
                      <td className="col-6 fw-bold">Name of Entity</td>
                      <td>Kerala Spacepark</td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <div className="">
                  Thank you. Please mark the transaction details in next page to
                  complete the registration process. KSPACE will verify the
                  payment and confirm your registration soon.
                </div>
              </div>
              </div>
              <div className="col-12 col-md-3">
                <img src="/qr.png" className="banking-qr"/>
              </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={(e) => handleClose()}>OK</Button>
            </Modal.Footer>
          </Modal>
        )}
        <div className="row px-4">
          <div className="col-lg-9 col-md-12 col-sm-12">
            <div className="detail-desc">
              <div
                dangerouslySetInnerHTML={{ __html: data[lang]?.Description }}
              />
              {data[lang]?.link && (
                <div className="row d-flex align-items-center mb-2">
                  <div className="col-3 font-weight-bold">Website Link</div>
                  <div className="col-1">:</div>
                  <div className="col-7">
                    {data[lang]?.link ? (
                      <a
                        href={`${
                          data[lang].link.startsWith("http")
                            ? data[lang].link.replace(/\\/g, "")
                            : `https://${data[lang].link.replace(/\\/g, "")}`
                        }`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: "#007bff",
                          textDecoration: "underline",
                          wordBreak: "break-word",
                        }}
                      >
                        {data[lang]?.link.replace(/\\/g, "")}
                      </a>
                    ) : (
                      "-"
                    )}
                  </div>
                </div>
              )}
              {data[lang]?.brochure && (
                <div className="row  d-flex align-items-center">
                  <button
                    className=" col-5 btn btn-approve btn-success"
                    onClick={() => window.open(data[lang]?.brochure, "_blank")}
                    style={{ minWidth: "250px" }}
                  >
                    Download Brochure
                  </button>
                </div>
              )}
              {data[lang]?.event_organized_type === "kspace" &&
                data[lang]?.paid != 0 && (
                  <>
                    <p className="font-weight-bold">
                      Event Fee : <CustomIcons iconName={"rupee"} />{" "}
                      <span className="fee">
                        {`${data[lang]?.paid ?? ""}`} /-
                      </span>
                    </p>
                    <p className="font-weight-bold">
                      Bank Details :{" "}
                      <span className="fee">{`${
                        data[lang]?.bank_details ?? ""
                      }`}</span>
                    </p>
                  </>
                )}
            </div>

            <div className="more-details">
              {data[lang]?.event_organized_type === "kspace" && (
                <>
                  {moment(
                    data[lang]?.booking_close_date &&
                      data[lang?.booking_close_date !== "01-01-1970"]
                      ? data[lang]?.booking_close_date
                      : data[lang]?.event_date_to,
                    "DD-MM-YYYY"
                  ).isSameOrAfter(moment(), "day") ? (
                    <div className="d-flex flex-col justify-content-center mt-3">
                      <div
                        className="col-9 btn btn-success ml-0"
                        disabled={data[lang]?.available_seats <= 0}
                        onClick={(e) => {
                          bookingOpen(e);
                        }}
                      >
                        Register Now
                      </div>
                    </div>
                  ) : (
                    <div className="d-flex flex-col justify-content-center mt-3">
                      <div
                        className="col-9 btn btn-success ml-0"
                        disabled={data[lang]?.available_seats <= 0}
                        onClick={(e) => {
                          bookingClosed(e);
                        }}
                      >
                        Register Now
                      </div>
                    </div>
                  )}

                  <div className="row mt-3 justify-content-center flex-wrap">
                    <div className="col-md-6 mt-3">
                      <TextField
                        id="outlined-basic"
                        placeholder="Enter Registration Reference Id for Initiating the Payment"
                        variant="outlined"
                        onChange={handleBookingIdChange}
                        value={bookingId}
                        name="id"
                        required
                      ></TextField>
                    </div>
                    <div
                      className="event-status-btn col-md-3 mt-3"
                      disabled={data[lang]?.available_seats <= 0}
                      onClick={() =>
                        handleStatusCheck(bookingId.replace(/\s+/g, ""))
                      }
                    >
                      Check Status
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="col-lg-3 col-md-12 col-sm-12">
            <div className="more-details">
              <div className="my-3 date">
                <p> Start Date</p>
                <p>
                  <img src="/resources/img/events/date.png" alt="" />{" "}
                  <span>{`${data[lang]?.eventDate ?? ""}`}</span>
                </p>
                <p> End Date</p>
                <p>
                  <img src="/resources/img/events/date.png" alt="" />{" "}
                  <span>{`${data[lang]?.event_date_to ?? ""}`}</span>
                </p>
                {data[lang]?.EventTimimg &&
                  data[lang]?.EventTimimg !== "undefined" && (
                    <p>
                      <img src="/resources/img/events/time.png" alt="" />{" "}
                      <span> {`${data[lang]?.EventTimimg ?? ""}`}</span>
                    </p>
                  )}
              </div>
              <div className="my-3 locate">
                <p>Venue</p>
                <p>
                  <img src="/resources/img/events/location.png" alt="" />
                  <span> {`${data[lang]?.location ?? ""}`}</span>
                </p>
              </div>
              <div className="my-3 org">
                <p>Organized By</p>
                <p>
                  <img src="/resources/img/events/head.png" alt="" />
                  <span> {`${data[lang]?.OrganizedBy ?? ""}`}</span>
                </p>
              </div>
              {data[lang]?.contact_no && (
                <div className="my-3 contact">
                  <p>Contact No</p>
                  <p>
                    <img src="/resources/img/events/phone.png" alt="" />
                    <span>{`${data[lang]?.contact_no ?? ""}`}</span>
                  </p>
                </div>
              )}
              {data[lang]?.event_email &&
                data[lang]?.event_email !== "undefined" && (
                  <div className="my-3 contact">
                    <p>Contact Email Id</p>
                    <p>
                      <img
                        src="/resources/img/events/emailbg.png"
                        alt=""
                        height={16}
                        width={19}
                      />
                      <span>{`${data[lang]?.event_email ?? ""}`}</span>
                    </p>
                  </div>
                )}
            </div>
          </div>
          <>
            <PaymentDialog
              open={pendingStatus}
              event={id}
              handleClose={paymentClose}
              booking_id={bookingId}
            />
          </>
          <Snackbar
            message={snackMessage}
            error={isSnackError}
            open={snackOpen}
            close={snackbarClose}
          />
          {regtype && (
            <Snackbar
              message={
                "Sorry the online registrations for this event are closed now!"
              }
              error={isSnackError}
              open={snackOpen}
              close={snackbarClose}
            />
          )}
        </div>
      </div>
    </div>
  );
}
